export default "__VITE_ASSET__CeBB8gjg__"